import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Truck } from '~/core/store/trucks/trucks.model';
import { MetaPageEnum } from '../../declaration/declaration';

declare const window: any;

@Injectable({
    providedIn: 'root'
})
export class GlobalUtils {
    constructor(
        @Inject(PLATFORM_ID) private platformId: string,
        private meta: Meta,
    ) {
    }

    isBrowser() {
        return isPlatformBrowser(this.platformId);
    }

    gtaEvent(event: string): void {
        if (this.isBrowser() && window.dataLayer) {
            window.dataLayer.push({ pageTitle: location.pathname, event });
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class MetaTagService {
    constructor(
        private meta: Meta,
        private title: Title,
        private translate: TranslateService
    ) { }

    updateTagFor(page: MetaPageEnum, data?: any) {
        let metaTitle = '';
        let metaDescription = '';
        let metaImage = '';
        let metaKeywords = '';
        let altImage = '';
        let imageTagContent = '';
        let imageTagAlt = '';

        switch (page) {
            case MetaPageEnum.Home:
                metaTitle = this.translate.instant('home/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('home/metadescription'.toLowerCase());
                metaImage = this.translate.instant('home/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('home/metakeywords'.toLowerCase());
                altImage = 'Volvo Used Trucks';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.OurStock:
                metaTitle = this.translate.instant('stock/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('stock/metadescription'.toLowerCase());
                metaImage = this.translate.instant('stock/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('stock/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.Services:
                metaTitle = this.translate.instant('services/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('services/metadescription'.toLowerCase());
                metaImage = this.translate.instant('services/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('services/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.ServicesVolvoSelected:
                metaTitle = this.translate.instant('services/volvoselected/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('services/volvoselected/metadescription'.toLowerCase());
                metaImage = this.translate.instant('services/volvoselected/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('services/volvoselected/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.ServicesFinancing:
                metaTitle = this.translate.instant('uk/services/financing/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/services/financing/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/services/financing/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/services/financing/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.ServicesContract:
                metaTitle = this.translate.instant('uk/services/servicecontract/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/services/servicecontract/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/services/servicecontract/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/services/servicecontract/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckModels:
                metaTitle = this.translate.instant('truckmodel/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('truckmodel/metadescription'.toLowerCase());
                metaImage = this.translate.instant('truckmodel/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('truckmodel/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckModelsFH16:
                metaTitle = this.translate.instant('uk/buyersguide/fh16/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/buyersguide/fh16/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/buyersguide/fh16/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/buyersguide/fh16/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckModelsFH16_Selected:
                metaTitle = this.translate.instant('truckmodel/volvofh16/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('truckmodel/volvofh16/metadescription'.toLowerCase());
                metaImage = this.translate.instant('truckmodel/volvofh16/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('truckmodel/volvofh16/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckModelsFH:
                metaTitle = this.translate.instant('uk/buyersguide/fh/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/buyersguide/fh/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/buyersguide/fh/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/buyersguide/fh/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckModelsFH_Selected:
                metaTitle = this.translate.instant('truckmodel/volvofh/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('truckmodel/volvofh/metadescription'.toLowerCase());
                metaImage = this.translate.instant('truckmodel/volvofh/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('truckmodel/volvofh/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckModelsFM:
                metaTitle = this.translate.instant('uk/buyersguide/fm/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/buyersguide/fm/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/buyersguide/fm/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/buyersguide/fm/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckModelsFM_Selected:
                metaTitle = this.translate.instant('truckmodel/volvofm/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('truckmodel/volvofm/metadescription'.toLowerCase());
                metaImage = this.translate.instant('truckmodel/volvofm/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('truckmodel/volvofm/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckModelsFMX:
                metaTitle = this.translate.instant('uk/buyersguide/fmx/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/buyersguide/fmx/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/buyersguide/fmx/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/buyersguide/fmx/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckModelsFMX_Selected:
                metaTitle = this.translate.instant('truckmodel/volvofmx/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('truckmodel/volvofmx/metadescription'.toLowerCase());
                metaImage = this.translate.instant('truckmodel/volvofmx/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('truckmodel/volvofmx/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckModelsFE:
                metaTitle = this.translate.instant('uk/buyersguide/fe/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/buyersguide/fe/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/buyersguide/fe/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/buyersguide/fe/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckModelsFL:
                metaTitle = this.translate.instant('uk/buyersguide/fl/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/buyersguide/fl/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/buyersguide/fl/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/buyersguide/fl/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.AboutUs:
                metaTitle = this.translate.instant('aboutus/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('aboutus/metadescription'.toLowerCase());
                metaImage = this.translate.instant('aboutus/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('aboutus/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.ContactUs:
                metaTitle = this.translate.instant('uk/contactus/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.TruckPage:
                if (data && data.truck) {
                    const truck = data.truck as Truck;
                    const make = truck.specification?.make || '';
                    const model = truck.specification?.model || '';
                    const horsePower = truck.specification?.horsePower + ' hp' || '';
                    const type = truck.specification?.superstructure.type || '';
                    const axleConfiguration = truck.specification?.axleConfiguration.engPhrase || '';
                    const mileage = truck.specification?.mileageKm + ' km' || '';

                    metaTitle = `${make} ${model} ${horsePower} ${type} ${axleConfiguration} ${mileage}`.replace(/\s+/g, ' ').trim();
                    metaDescription = metaTitle + ' ' + this.translate.instant('truckpage/metadescription');
                    metaImage = truck.MetaAltImage || '';
                    metaKeywords = `${make},${model},${horsePower},${type}`;
                    altImage = make + ' ' + model;
                    imageTagAlt = this.translate.instant('truckpage/metaimage');
                    imageTagContent = metaTitle + ' ' + imageTagAlt;
                }
                break;
            case MetaPageEnum.WhatCustomersSay:
                metaTitle = this.translate.instant('uk/aboutus/whatcustomersay/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/aboutus/whatcustomersay/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/aboutus/whatcustomersay/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/aboutus/whatcustomersay/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.WhatWeHave:
                metaTitle = this.translate.instant('uk/aboutus/whatwehave/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/aboutus/whatwehave/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/aboutus/whatwehave/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/aboutus/whatwehave/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.WhatWhoWeAre:
                metaTitle = this.translate.instant('uk/aboutus/whoweare/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/aboutus/whoweare/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/aboutus/whoweare/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/aboutus/whoweare/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CentreBanbury:
                metaTitle = this.translate.instant('uk/contactus/banburymetatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/banburymetadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/banburyaltimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/banburymetakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CentreEly:
                metaTitle = this.translate.instant('uk/contactus/elymetatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/elymetadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/elyaltimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/elymetakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CentreBardon:
                metaTitle = this.translate.instant('uk/contactus/bardonmetatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/bardonmetadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/bardonaltimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/bardonmetakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CentreEnfield:
                metaTitle = this.translate.instant('uk/contactus/enfieldmetatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/enfieldmetadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/enfieldaltimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/enfieldmetakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CentreFelixstowe:
                metaTitle = this.translate.instant('uk/contactus/felixstowemetatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/felixstowemetadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/felixstowealtimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/felixstowemetakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CentreGlasgowWest:
                metaTitle = this.translate.instant('uk/contactus/glasgowwestmetatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/glasgowwestmetadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/glasgowwestaltimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/glasgowwestmetakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CentreHayes:
                metaTitle = this.translate.instant('uk/contactus/hayesmetatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/hayesmetadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/hayesaltimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/hayesmetakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CentreReading:
                metaTitle = this.translate.instant('uk/contactus/readingmetatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/readingmetadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/readingaltimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/readingmetakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CentreWashington:
                metaTitle = this.translate.instant('uk/contactus/washingtonmetatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/washingtonmetadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/washingtonaltimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/washingtonmetakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CentreWellingborough:
                metaTitle = this.translate.instant('uk/contactus/wellingboroughmetatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/wellingboroughmetadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/wellingboroughaltimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/wellingboroughmetakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CentreEdinburgh:
                metaTitle = this.translate.instant('uk/contactus/edinburghmetatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/contactus/edinburghmetadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/contactus/edinburghaltimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/contactus/edinburghmetakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.CustomisationPage:
                metaTitle = this.translate.instant('uk/services/customisation/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/services/customisation/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/services/customisation/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/services/customisation/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.FinancingPage:
                metaTitle = this.translate.instant('financing/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('financing/metadescription'.toLowerCase());
                metaImage = this.translate.instant('financing/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('financing/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.VolvoSelectedFAQ:
                metaTitle = this.translate.instant('uk/services/volvoselectedfaq/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/services/volvoselectedfaq/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/services/volvoselectedfaq/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/services/volvoselectedfaq/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.VolvoConnectPage:
                metaTitle = this.translate.instant('uk/services/volvoconnect/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/services/volvoconnect/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/services/volvoconnect/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/services/volvoconnect/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.ServiceEconomyPage:
                metaTitle = this.translate.instant('uk/services/economy/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/services/economy/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/services/economy/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/services/economy/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.VolvoExportPage:
                metaTitle = this.translate.instant('uk/services/export/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/services/export/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/services/export/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/services/export/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.VolvoSelectedPage:
                metaTitle = this.translate.instant('uk/services/volvoselected/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/services/volvoselected/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/services/volvoselected/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/services/volvoselected/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.UTCustomisationPage:
                metaTitle = this.translate.instant('uk/services/utcustomisation/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/services/utcustomisation/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/services/utcustomisation/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/services/utcustomisation/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.EconomyFAQPage:
                metaTitle = this.translate.instant('uk/services/economyfaq/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/services/economyfaq/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/services/economyfaq/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/services/economyfaq/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.UnsubscribePage:
                metaTitle = this.translate.instant('unsubscribe/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('unsubscribe/metadescription'.toLowerCase());
                metaImage = this.translate.instant('unsubscribe/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('unsubscribe/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.VehicleOfferRemainingWarranty:
                metaTitle = this.translate.instant('uk/vehicleoffers/warranty/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/vehicleoffers/warranty/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/vehicleoffers/warranty/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/vehicleoffers/warranty/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.VehicleOfferVolvoApproved:
                metaTitle = this.translate.instant('uk/vehicleoffers/approved/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/vehicleoffers/approved/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/vehicleoffers/approved/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/vehicleoffers/approved/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.VehicleOfferVolvoEconomy:
                metaTitle = this.translate.instant('uk/vehicleoffers/economy/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/vehicleoffers/economy/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/vehicleoffers/economy/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/vehicleoffers/economy/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            case MetaPageEnum.BuyersGuide:
                metaTitle = this.translate.instant('uk/buyersguide/metatitle'.toLowerCase());
                metaDescription = this.translate.instant('uk/buyersguide/metadescription'.toLowerCase());
                metaImage = this.translate.instant('uk/buyersguide/altimage'.toLowerCase());
                metaKeywords = this.translate.instant('uk/buyersguide/metakeywords'.toLowerCase());
                altImage = 'alt';
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
            default:
                imageTagContent = metaImage || metaTitle;
                imageTagAlt = altImage;
                break;
        }

        this.title.setTitle(metaTitle);
        this.meta.updateTag({ name: 'description', content: metaDescription });
        this.meta.updateTag({ property: 'og:title', content: metaTitle });
        this.meta.updateTag({ property: 'og:description', content: metaDescription });
        this.meta.updateTag({ property: 'og:image', content: metaImage });
        this.meta.updateTag({ name: 'image', content: imageTagContent, alt: imageTagAlt });
        this.meta.updateTag({ name: 'keywords', content: metaKeywords });
    }
}

